import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardLayout from "../../../LayoutNavbar/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../LayoutNavbar/Navbars/DashboardNavbar";
import "./announcement.scss";
import { Button, Card, Descriptions } from "antd";
import moment from "moment";

function EmployeeAnnouncementDetail() {
  const location = useLocation();
  const { announcement } = location.state || {};
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/employeedashboard");
  };

  if (!announcement) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <div className="body flex-grow-1 px-3">
          <Card className="card-professional" title="Announcement Detail">
            <p>No announcement details available.</p>
            <Button type="default" onClick={handleBack}>
              Back to Dashboard
            </Button>
          </Card>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <DashboardNavbar />
        <div className="body flex-grow-1 px-3">
          <Card
            className="card-professional"
            title="Announcement Details"
            extra={
              <Button type="default" onClick={handleBack}>
                Back to Dashboard
              </Button>
            }
          >
            <Descriptions bordered column={1} size="middle">
              <Descriptions.Item label="Title">{announcement.title || "—"}</Descriptions.Item>
              <Descriptions.Item label="Message">{announcement.message || "—"}</Descriptions.Item>
              <Descriptions.Item label="Announced On">
                {announcement.createdOn
                  ? moment(announcement.createdOn).format("DD MMM YYYY, hh:mm A")
                  : "—"}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </div>
      </div>
    </DashboardLayout>
  );
}

export default EmployeeAnnouncementDetail;
